import { useCore } from '@/composables/core'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "referral.code", data: { referral_code: "123" } }}))
 */

const name = 'referral.code'

const callback = ({ referral_code }) => {
  const { store } = useCore()

  // shortcut: already logged in
  if (store.state.identity?.accessToken) return

  window.location = window.location.origin
    + store.state.app.basePath
    + `/${store.state.app.language}-${store.state.app.country}/onboarding`
    + `?referral=${referral_code}`
}

export default { name, callback }
